// extracted by mini-css-extract-plugin
module.exports = {"Header":"Layout_Header__2KQBF","Icon":"Layout_Icon__3Y6dK","Body":"Layout_Body__GYVSx"};